<template>
  <div id="app">
    <b-navbar toggleable="md" type="dark" variant="info">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand :to="{name: 'landing-page'}">
        <img src="./assets/img/logo.png" style="max-height: 41px;" alt="LOGO">
      </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item v-b-modal.modalSync>Sincronizar</b-nav-item>
          <b-nav-item :to="{ name : 'Passport' }">Passport</b-nav-item>
          <b-nav-item :to="{ name : 'Status' }">Estatus</b-nav-item>
          <b-nav-item-dropdown>
            <template slot="button-content">
              <em>Puntos de Control</em>
            </template>
            <b-dropdown-item
                    href="#"
                    v-for="checkpoint in checkpoints"
                    :to="{name: 'check-fastpass', params: {checkPointId: checkpoint.checkPointId}}"
                    :key="checkpoint.id"
                    :active="false"
                    @click="selectCheckPoint(checkpoint)">
              {{ checkpoint.name }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="#" disabled>{{ checkPoint.name }}</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="#" disabled>{{ session.user.email }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-modal id="modalSync" ref="modalSync" title="Sincronizar" @hidden="onHidden">
        <b-container fluid>
            <b-form>
                <b-form-group label="Tipo de sincronización">
                  <select class="form-control" required v-model="syncOptions.type">
                    <option value="fast_pass">Fast Passes</option>
                    <option value="fast_pass_short_ids">Fast Pass Short Ids</option>
                  </select>
                </b-form-group>
                <b-form-group label="Opciones">
                    <b-form-checkbox
                        v-model="syncOptions.replace"
                        :disabled="syncIsLoading"
                    >
                      Actualizar pases existentes.
                    </b-form-checkbox>
                    <b-form-checkbox
                        v-model="syncOptions.fast"
                        :disabled="syncIsLoading"
                    >
                      Sincronización rapida.
                    </b-form-checkbox>
                </b-form-group>
            </b-form>
            <div class="row">
                <div class="col-12 text-center">
                    <b-alert variant="success" :show="showSyncMessage">Sincronización en progreso, podra revisar el progreso en esta pantalla y se notificara cuando termine.</b-alert>
                    <b-progress :show="showSyncMessage" :value="progressCounter" :max="100" show-progress animated />
                  <span class="text-warning" v-show="showSyncMessage">El proceso puede tardar varios minutos, favor de esperar.</span>
                </div>
            </div>
        </b-container>
        <div slot="modal-footer">
            <b-button type="button" @click="sync" variant="primary" :disabled="syncIsLoading">Sincronizar</b-button>
        </div>
    </b-modal>
    <router-view></router-view>
  </div>
</template>

<script>
  import Config from './config/app'
  import Auth from './services/auth'
  import axios from 'axios'
  import swal from 'sweetalert2'
  import { mapActions } from 'vuex'
  import io from 'socket.io-client'

  export default {
    name: 'fastpass-local',
    data () {
      return {
        menu: [],
        checkPoint: {},
        checkpoints: [],
        syncIsLoading: false,
        showSyncMessage: false,
        progressCounter: 0,
        syncOptions: {
          replace: false,
          fast: false,
          type: 'fast_pass'
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      ...mapActions([
        'setSession'
      ]),
      async getMenu (token) {
        try {
          const response = await axios.get(`${Config.services.menu}`, {
            params: {
              token
            }
          })

          this.checkpoints = response.data
          await this.setDefaultMenu()
        } catch (e) {
          return swal({
            type: 'error',
            title: 'Oops...',
            text: e.message
          })
        }
      },
      async init () {
        try {
          const session = await Auth.loginService()
          this.setSession(session)
          await this.getMenu(session.token)
        } catch (e) {
          this.setSession(null)
          await this.getMenu(null)
        }
      },
      async setDefaultMenu() {
        const defaultCheckpoint = this.checkpoints.find(c => c.checkPointId === Config.defaultCheckPointId)

        if (defaultCheckpoint) {
          await this.selectCheckPoint(defaultCheckpoint)
          const validationMode = Config.validationMode || 'fastPass'

          if (this.$route.query.redirect === 'off') {
            return
          }

          if (validationMode === 'qr') {
            this.$router.push({
              name: 'Passport',
            })

            return
          }

          this.$router.push({
            name: 'check-fastpass',
            params: {
              checkPointId: defaultCheckpoint.checkPointId
            }
          })
        }
      },
      async selectCheckPoint (checkPoint) {
        this.checkPoint = checkPoint
        await this.$http.put(`${Config.services.setCheckpointId}`, { id: checkPoint.checkPointId })
      },
      async sync () {
        try {
          this.progressCounter = 0
          this.syncIsLoading = false
          await axios.get(`${Config.services.sync}`, {
            params: this.syncOptions
          })

          this.showSyncMessage = true
          this.syncIsLoading = true

          const socket = io(`${Config.socketUrl}`)
          socket.on('finishSync', () => {
            swal({
              position: 'top-end',
              type: 'success',
              title: 'Sincronización realizada con exito.',
              showConfirmButton: false,
              timer: 2500
            })
            this.progressCounter = 100
            this.syncIsLoading = false
          })
          socket.on('updateProgress', data => {
            this.progressCounter = data.progress
          })
        } catch (e) {
          this.$refs.modalSync.hide()

          if (e.message === 'Network Error') {
            return swal({
              type: 'error',
              title: 'Oops...',
              text: 'No se puede comunicar con el servidor local'
            })
          }

          if (e.response !== undefined
            && e.response.data !== undefined
            && e.response.data.code === 'NetworkError') {
            swal({
              type: 'error',
              title: 'Oops...',
              text: e.response.data.error
            })
          }
        }
      },
      onHidden () {
        this.syncOptions = {
          replace: false,
          fast: false
        }
      }
    },
    computed: {
      session () {
        return this.$store.getters.session || {user: {email: null, token: null}}
      }
    }
  }
</script>

<style>
  /* CSS */
</style>
